import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const SOCIALS = [
    { label: "Facebook", href: "https://www.facebook.com/giovanni.delorenzo.921", testid: "social-facebook", Icon: Facebook },
    { label: "Instagram", href: "https://www.instagram.com/giovanni.delorenzo", testid: "social-instagram", Icon: Instagram },
    { label: "TikTok", href: "https://www.tiktok.com/@dott.giovannidelorenzo", testid: "social-tiktok", tiktok: true },
    { label: "LinkedIn", href: "https://www.linkedin.com/in/dott-giovanni-de-lorenzo-561927119", testid: "social-linkedin", Icon: Linkedin },
    { label: "YouTube", href: "https://youtube.com/@dottgiovannidelorenzo", testid: "social-youtube", Icon: Youtube },
];

const TikTokIcon = ({ size = 18 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M12.53.02C13.84 0 15.14.01 16.44 0c.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
    </svg>
);

export const Footer = () => (
    <footer className="bg-ink text-cream" data-testid="footer">
        <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-16 md:py-20 grid gap-12 md:grid-cols-3">
            <div>
                <p className="font-serif text-2xl font-semibold">Psicologo e Psicoterapeuta Dott. Giovanni De Lorenzo</p>
                <p className="mt-4 text-sm text-cream/60 leading-relaxed max-w-xs">
                    Uno spazio di ascolto, comprensione e consapevolezza per affrontare ciò che stai vivendo.
                </p>
                <div className="mt-6 flex items-center gap-3" data-testid="footer-socials">
                    {SOCIALS.map((s) => (
                        <a
                            key={s.label}
                            href={s.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={`Segui il Dott. De Lorenzo su ${s.label}`}
                            data-testid={s.testid}
                            className="flex h-10 w-10 items-center justify-center rounded-full border border-cream/20 text-cream/70 hover:bg-cream hover:text-ink hover:border-cream transition-all duration-300"
                        >
                            {s.tiktok ? <TikTokIcon size={16} /> : <s.Icon size={17} strokeWidth={1.8} />}
                        </a>
                    ))}
                </div>
            </div>
            <div>
                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-cream/50">Contatti</p>
                <ul className="mt-5 space-y-3 text-sm text-cream/75">
                    <li data-testid="footer-phone">Telefono: <a href="tel:+393341768041" className="hover:text-cream transition-colors duration-300">+39 334 176 8041</a></li>
                    <li data-testid="footer-email">Email: <a href="mailto:studio@psicologogiovannidelorenzo.it" className="hover:text-cream transition-colors duration-300">studio@psicologogiovannidelorenzo.it</a></li>
                    <li data-testid="footer-address">Studio: Via Alessandro Volta, 85025 Melfi (PZ)</li>
                    <li data-testid="footer-albo">Albo degli Psicologi — Sezione A, n. 9539</li>
                </ul>
            </div>
            <div>
                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-cream/50">Note legali</p>
                <ul className="mt-5 space-y-3 text-sm">
                    <li>
                        <Link to="/privacy-policy" data-testid="footer-privacy-link" className="text-cream/75 hover:text-cream transition-colors duration-300">
                            Privacy Policy
                        </Link>
                    </li>
                    <li>
                        <Link to="/cookie-policy" data-testid="footer-cookie-link" className="text-cream/75 hover:text-cream transition-colors duration-300">
                            Cookie Policy
                        </Link>
                    </li>
                    <li>
                        <button
                            data-testid="footer-contatti-link"
                            onClick={() => scrollToId("#contatti")}
                            className="text-cream/75 hover:text-cream transition-colors duration-300"
                        >
                            Contatti
                        </button>
                    </li>
                </ul>
            </div>
        </div>
        <div className="border-t border-cream/10">
            <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-6 flex flex-col sm:flex-row justify-between gap-2 text-xs text-cream/40">
                <p>© {new Date().getFullYear()} Dott. Giovanni De Lorenzo — Tutti i diritti riservati</p>
                <p>P.IVA 03113480648</p>
            </div>
        </div>
    </footer>
);
